import React, { useState } from "react";
import helpDesk from "../images/help-desk-1.png";
import kccLogo from "../images/kcc-knust.png";
import chaplaincyLogo from "../images/scc.png";
import dosaLogo from "../images/saf.png";
import policeLogo from "../images/gh-police.png";
import fireLogo from "../images/fire-service.png";
import ecgLogo from "../images/ecg-ghana.png";
import {
	MdCall,
	MdEmail,
	MdAccessTime,
	MdLanguage,
	MdOpenInNew,
	MdExpandMore,
	MdLocalHospital,
	MdLocalPolice,
	MdLocalFireDepartment,
	MdBolt,
	MdSavings,
} from "react-icons/md";

const tel = (number) => `tel:${number.replace(/[^\d+]/g, "")}`;

const internalServices = [
	{
		id: "dosa",
		name: "Directorate of Student Affairs (DoSA)",
		logo: dosaLogo,
		paragraphs: [
			"The office of the Directorate of Students affairs formerly Dean of Students was formally established in 1997 to provide the needed necessary welfare support services for students during their period of study at KNUST. The office, over the years, has sought to fulfil its mission by assisting students to understand in both specific and general terms how the university operates both at the social and academic levels.",
			"This consequently enables us to understand regulations and procedures and ways to getting their needs met. The office had further provided opportunities for students to develop and enhance their leadership skills by involving them in decision making processes, supporting advocacy for students and providing and involving them in conflict resolution techniques.",
			"The office is organized into sections to help provide support to the student body of the university community;",
		],
		sections: [
			"Administration",
			"Students Conduct and Discipline",
			"Students Housing and Residence Life",
			"Students Support and Financial Services",
			"Student Guidance and Counselling",
			"International Student Affairs",
			"Student Representative Council Affairs",
		],
		contacts: [{ type: "phone", label: "DoSA Office Line", value: "020 824 4000" }],
	},
	{
		id: "kcc",
		name: "Counselling Centre (KCC)",
		logo: kccLogo,
		paragraphs: [
			"The KNUST Counselling Center (KCC) is a mental health facility dedicated to the promotion of a healthy University Environment for students, staff and their dependents. The center has well trained and professional Counsellors and Clinical Psychologists who provide an emotionally safe, confidential, compassionate and respectful environment that foster development and greater subjective wellbeing of clients.",
			"Since its initial foundation in 1993, the KCC has evolved and grown to extend varied psychological and counselling services to communities beyond the University. We are committed to a cutting-edge and high-quality approach to each of our services toward becoming a global leader as a University mental health and wellbeing center.",
		],
		contacts: [
			{ type: "phone", label: "Call Line", value: "050-644-9747" },
			{ type: "phone", label: "Call Line", value: "059-4399-7772" },
			{ type: "email", label: "Email", value: "counsellingcentre@gmail.com" },
			{ type: "web", label: "Website", value: "counsellingcentre@knust.edu.gh" },
		],
		hours: "Monday to Friday - 8:00am to 5:00pm",
	},
	{
		id: "chaplaincy",
		name: "Chaplaincy Office",
		logo: chaplaincyLogo,
		paragraphs: [
			"The Protestant Chaplaincy is the umbrella for all religious groups and bodies in the University. It is dedicated to facilitating the general well-being of staff and students through pastoral guidance. The unit is headed by the Protestant Chaplain, who serves as the spiritual figure of the University. The major role of the Protestant Chaplaincy is the coordination of all the activities of Christian and Non-Christian groups, through the Students Chaplaincy Council (SCC)",
			"The Students Chaplaincy Council is an Administrative body of all registered Christian denominations that liaises with the Protestant Chaplaincy concerning students activities.",
		],
		contacts: [
			{ type: "phone", label: "Office Line", value: "055-834-1461" },
			{ type: "email", label: "Email", value: "protestantchaplaincy123@gmail.com" },
		],
		hours: "Monday to Friday - 8:00am to 5:00pm",
	},
	{
		id: "ssfs",
		name: "Students Support and Financial Services",
		icon: <MdSavings />,
		paragraphs: [
			"The Student Affairs is a department under the Dean of Students Office to Help attend to the Financial Needs of Students through scholarships and also a center for International Exchange Programme.",
		],
		link: {
			label: "Read More",
			href: "https://www.knust.edu.gh/index.php/students/scholarships-and-grants",
		},
	},
];

const keyContacts = [
	{ label: "DoSA Office Line", value: "020 824 4000" },
	{ label: "Dr. Faizal Adams", value: "024 205 2808" },
];

const externalServices = [
	{
		name: "Tek Hospital",
		icon: <MdLocalHospital />,
		tone: "red",
		lines: [{ number: "032 206 0300" }, { number: "032 206 0320" }],
	},
	{
		name: "Ghana Police Service",
		icon: <MdLocalPolice />,
		logo: policeLogo,
		tone: "blue",
		lines: [
			{ number: "191" },
			{ number: "18 555" },
			{ number: "032 206 0051", note: "KNUST" },
			{ number: "032 202 1341", note: "Oforikrom" },
			{ number: "029 920 2240", note: "Kumasi" },
			{ number: "029 920 7770", note: "Kumasi" },
		],
	},
	{
		name: "Ghana Fire Service",
		icon: <MdLocalFireDepartment />,
		logo: fireLogo,
		tone: "orange",
		lines: [
			{ number: "024 486 5319", note: "KNUST" },
			{ number: "032 239 2292", note: "KNUST" },
			{ number: "032 202 2222" },
		],
	},
	{
		name: "ECG",
		icon: <MdBolt />,
		logo: ecgLogo,
		tone: "amber",
		lines: [{ number: "030 261 1611" }],
	},
];

const emergencyLines = [
	{ label: "Police", number: "191", icon: <MdLocalPolice /> },
	{ label: "Fire (KNUST)", number: "024 486 5319", icon: <MdLocalFireDepartment /> },
	{ label: "Tek Hospital", number: "032 206 0300", icon: <MdLocalHospital /> },
];

function ContactItem({ contact }) {
	const icon =
		contact.type === "email" ? <MdEmail /> : contact.type === "web" ? <MdLanguage /> : <MdCall />;
	const href =
		contact.type === "email"
			? `mailto:${contact.value}`
			: contact.type === "phone"
			? tel(contact.value)
			: null;
	return (
		<li className="hd-contact">
			<span className="hd-contact-icon">{icon}</span>
			<span className="hd-contact-body">
				<span className="hd-contact-label">{contact.label}</span>
				{href ? (
					<a href={href} className="hd-contact-value">
						{contact.value}
					</a>
				) : (
					<span className="hd-contact-value">{contact.value}</span>
				)}
			</span>
		</li>
	);
}

function ServiceCard({ service }) {
	const [expanded, setExpanded] = useState(false);
	const [first, ...rest] = service.paragraphs;
	const canExpand = rest.length > 0 || service.sections;

	return (
		<article className="hd-service" id={service.id}>
			<header className="hd-service-head">
				<span className="hd-service-logo">
					{service.logo ? <img src={service.logo} alt="" /> : service.icon}
				</span>
				<h3 className="hd-service-title">{service.name}</h3>
			</header>

			<p className="hd-service-text">{first}</p>
			{canExpand && (
				<div className={`hd-more${expanded ? " is-open" : ""}`}>
					<div className="hd-more-inner">
						{rest.map((p, i) => (
							<p key={i} className="hd-service-text">
								{p}
							</p>
						))}
						{service.sections && (
							<ul className="hd-tags">
								{service.sections.map((s) => (
									<li key={s}>{s}</li>
								))}
							</ul>
						)}
					</div>
				</div>
			)}
			{canExpand && (
				<button
					type="button"
					className={`hd-toggle${expanded ? " is-open" : ""}`}
					aria-expanded={expanded}
					onClick={() => setExpanded(!expanded)}
				>
					{expanded ? "Show less" : "Read more"} <MdExpandMore />
				</button>
			)}

			{(service.contacts || service.hours || service.link) && (
				<footer className="hd-service-foot">
					{service.contacts && (
						<ul className="hd-contacts">
							{service.contacts.map((c) => (
								<ContactItem key={c.value} contact={c} />
							))}
						</ul>
					)}
					{service.hours && (
						<p className="hd-hours">
							<MdAccessTime /> {service.hours}
						</p>
					)}
					{service.link && (
						<a
							className="hd-link"
							href={service.link.href}
							target="_blank"
							rel="noopener noreferrer"
						>
							{service.link.label} <MdOpenInNew />
						</a>
					)}
				</footer>
			)}
		</article>
	);
}

export default function HelpDesk(props) {
	return (
		<div className="hd-page">
			{/* intro */}
			<section className="hd-hero">
				<div className="container hd-hero-grid">
					<div>
						<span className="lp-kicker">Help Desk</span>
						<h1 className="hd-hero-title">Quick access to information</h1>
						<p className="hd-hero-text">
							Do you have any challenge related to your Hostel / Homestel that demands
							the following help lines? Do not hesitate, reach out to them and they are
							willing to help in the shortest time possible. Fire Service Hotlines,
							Chaplaincy Hotline, Counselling Hotlines, Hospital Call lines and the
							Ghana Police Service
						</p>
						<nav className="hd-jump" aria-label="Help desk sections">
							<a href="#internal">Internal Services</a>
							<a href="#contact">Get In Touch</a>
							<a href="#external">External Services</a>
						</nav>
					</div>
					<img src={helpDesk} alt="" className="hd-hero-img" />
				</div>
			</section>

			{/* emergency strip */}
			<div className="container">
				<div className="hd-emergency" role="region" aria-label="Emergency lines">
					<span className="hd-emergency-label">Emergency</span>
					<div className="hd-emergency-lines">
						{emergencyLines.map((line) => (
							<a key={line.label} href={tel(line.number)} className="hd-emergency-line">
								{line.icon}
								<span>
									<small>{line.label}</small>
									{line.number}
								</span>
							</a>
						))}
					</div>
				</div>
			</div>

			{/* internal services */}
			<section className="container hd-section" id="internal">
				<h2 className="hd-section-title">Internal Services</h2>
				<div className="hd-services">
					{internalServices.map((service) => (
						<ServiceCard key={service.id} service={service} />
					))}
				</div>
			</section>

			{/* key contacts */}
			<section className="container hd-section" id="contact">
				<div className="hd-touch">
					<div className="hd-touch-head">
						<span className="hd-touch-icon">
							<MdCall />
						</span>
						<div>
							<h2 className="hd-touch-title">Get In Touch</h2>
							<p className="hd-touch-text">Tap a number to call directly.</p>
						</div>
					</div>
					<div className="hd-touch-list">
						{keyContacts.map((c) => (
							<a key={c.label} href={tel(c.value)} className="hd-touch-item">
								<span className="hd-touch-name">{c.label}</span>
								<span className="hd-touch-number">
									<MdCall /> {c.value}
								</span>
							</a>
						))}
					</div>
				</div>
			</section>

			{/* external services */}
			<section className="container hd-section" id="external">
				<h2 className="hd-section-title">External Services</h2>
				<div className="hd-external">
					{externalServices.map((service) => (
						<article key={service.name} className="hd-ext">
							<header className="hd-ext-head">
								<span className={`hd-ext-icon hd-tone-${service.tone}`}>
									{service.logo ? <img src={service.logo} alt="" /> : service.icon}
								</span>
								<div>
									<h3 className="hd-ext-title">{service.name}</h3>
									<span className="hd-ext-sub">Call Lines</span>
								</div>
							</header>
							<ul className="hd-lines">
								{service.lines.map((line) => (
									<li key={line.number}>
										<a href={tel(line.number)} className="hd-line">
											<span className="hd-line-number">
												<MdCall /> {line.number}
											</span>
											{line.note && <span className="hd-line-note">{line.note}</span>}
										</a>
									</li>
								))}
							</ul>
						</article>
					))}
				</div>
			</section>
		</div>
	);
}
